<template>
  <section>
    <page-header
      :actions="[
        {
          text: 'Añadir',
          icon: 'fas fa-save',
          variant: 'success',
          component: 'ActionButton',
          click: () => this.add(),
          visible: userHasPermissions('provider.specialists.add'),
        },
      ]"
      :page="page"
    />

    <filter-manager
      ref="filterComponent"
      v-model="filterModel"
      :filters="filtersConfig"
      @search="search"
    />

    <separator
      v-if="hasSearched"
      class="my-3"
      text="Resultado de Especialistas"
    />

    <result-not-found v-if="hasSearched && results.length === 0" />
    <div v-for="item in results" :key="item.id" class="">
      <custom-callout :class="!showAlert(item) && 'mb-3'">
        <div class="row">
          <div class="col-sm border-right">
            <span class="data-name">Especialista:</span>
            <p class="data">
              {{ item.fullName }}
            </p>
          </div>
          <div class="col-sm">
            <span class="data-name">Número Especialista:</span>
            <p class="data">
              {{ item.id }}
            </p>
          </div>
          <div class="col-sm-12 col-md-2">
            <span class="data-name">Estatus:</span>
            <div class="w-70">
              <balloon
                :color-icon="`color-primary-${item.isActive ? '7' : '6'}`"
                icon="fas fa-circle"
                :text="item.isActive ? 'Activo' : 'Inactivo'"
                :with-border="false"
              />
            </div>
          </div>
          <div class="col-md-4 col-sm-12">
            <span class="data-name">Especialidad:</span>
            <p class="data">
              {{ item.specialty }}
            </p>
          </div>
          <div
            class="col d-flex align-items-center justify-content-md-end justify-content-sm-start"
          >
            <div class="w-sm-40 w-md-70">
              <action-button
                class="w-100"
                i="fas fa-file-import"
                text="Entrar"
                variant="outline-success"
                @click="
                  () =>
                    $router.push({
                      name: 'specialist-management',
                      params: {
                        title: 'Especialista: Editar',
                        specialistId: item.id,
                        companyId: companyId,
                        fiscalYearId: item.fiscalYearId,
                        isActive: item.isActive,
                        isDEPR:
                          item.moreThanOneCompany && item.hasExcemptionApproved,
                      },
                    })
                "
              />
            </div>
          </div>
        </div>
      </custom-callout>
      <div
        v-if="showAlert(item)"
        class="alert rb-alert px-2 rounded pt-2 mb-n0 alert-container mb-3"
      >
        <div class="d-flex align-items-center">
          <em
            class="fa fa-bell-exclamation font-16 pl-2 ml-1 color-secondary-40"
          />
          <div
            class="font-16 font-weight-normal color-secondary-40 ml-3 alert-text"
          >
            <div v-html="alertText(item)" />
            <p
              v-if="item.moreThanOneCompany && item.hasExcemptionDenied"
              class="mb-0"
            >
              La dispensa fue denegada por el Departamento de Educación de
              Puerto Rico, para ver la razón
              <a
                class="text-dark-yellow text-underline font-weight-bold cursor-pointer"
                @click="navigateToDispenseManagement"
              >
                oprima aquí.
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
    <pagination
      v-if="this.results.length > 0 && this.pagination.totalItemCount > 15"
      :data="this.pagination"
      @pagination-go-page="pageChanged"
    />
  </section>
</template>

<script>
import CustomCallout from '@/components/common/CustomCallout';
import storeMixin from '@/shared/mixins/storeGenerator';
import ResultNotFound from '@/components/common/ResultNotFound';
import FilterManager from 'FilterManager';
import ServiceTypeCategories from '@/utils/constants/serviceTypeCategories.js';

import {
  getCodeServiceTypes as getServiceTypes,
  getServicePlaces,
  getSpecialists,
  providersList,
  getSpecialistYears,
  specialistsList,
  getMunicipalities,
  getServicesDiscipline,
} from '@/modules/provider/api';

import { getTypePlaces } from '@/modules/shared/code.api';

import alert from '@/mixins/alert.mixin';
import Pagination from '@/components/common/Pagination';
import { mapState } from 'vuex';

export default {
  name: 'SearchSpecialist',
  components: {
    CustomCallout,
    Pagination,
    ResultNotFound,
    FilterManager,
  },
  filters: {
    services(value) {
      let services = value.map((item) => item.name);
      return [...new Set(services)].join();
    },
  },
  mixins: [storeMixin, alert],
  data() {
    return {
      filters: {
        typePlaces: [],
        servicePlaces: [],
        services: [],
        servicesTypes: [],
        providers: [],
        municipalities: [],
        years: [],
        status: [
          { id: -1, name: 'Todos' },
          { id: 0, name: 'Inactivo' },
          { id: 1, name: 'Activo' },
        ],
        specialists: [],
      },
      results: [],
      hasSearched: false,
      filterModel: {},
      pagination: {
        currentPage: this.getPreviousPage() || 1,
        totalItemCount: 0,
        pageCount: 1,
        count: 1,
        pageSize: 15,
      },
      currentYear: this.$store.state.$_common.currentAcademicYear,
    };
  },
  computed: {
    ...mapState('$_user', ['user']),
    page() {
      return {
        title: 'Especialistas',
        icon: 'fas fa-user-tie',
        routes: ['Proveedor', 'Especialistas', 'Especialistas'],
      };
    },
    companyId() {
      return (
        parseInt(this.user.profile.companyid) || this.filterModel.provider.id
      );
    },
    currentAcademicYearId() {
      return this.currentAcademicYear().id;
    },
    filtersConfig() {
      return [
        {
          //config component
          name: 'academicYear',
          component: 'CustomDropDown',
          options: this.filters.years,
          placeholder: 'Seleccione el año',
          fieldName: 'description',
          fieldKey: 'id',
          validations: 'required',
          clearable: false,
          class: 'col-md-4',
          //config manager
          initialValue: this.currentYear,
          onChanged: this.onYearChanged,
          immediateOnChanged: true,
          clearModelsOnUpdate: ['provider', 'specialist'],
        },
        {
          name: 'provider',
          component: 'CustomDropDown',
          options: this.filters.providers,
          placeholder: 'Seleccione el proveedor',
          fieldName: 'name',
          fieldKey: 'id',
          clearable: true,
          class: 'col-md-4',
          validations: 'required',
          onChanged: this.onProviderChanged,
          immediateOnChanged: true,
          error: 'Es requerido seleccionar Proveedor',
          clearModelsOnUpdate: [
            'servicePlace',
            'service',
            'typePlace',
            'serviceType',
          ],
          returnModel: true,
          visible: this.userHasPermissions('provider.specialist.dropdown.view'),
          disabled: this.filters.providers.length == 1,
        },
        {
          name: 'specialist',
          component: 'CustomDropDown',
          options: this.filters.specialists,
          placeholder: 'Seleccione Especialista',
          fieldName: 'name',
          fieldKey: 'id',
          clearable: true,
          class: 'col-md-4',
          returnModel: true,
          disabled: this.filters.specialists.length == 1,
        },
        {
          name: 'typePlace',
          component: 'CustomDropDown',
          options: this.filters.typePlaces,
          placeholder: 'Seleccione',
          label: 'Tipo de Lugar:',
          fieldName: 'name',
          fieldKey: 'id',
          clearable: true,
          isAdvanced: true,
          class: 'col-md-4',
          onChanged: this.onTypePlaceChanged,
          returnModel: true,
          clearModelsOnUpdate: ['servicePlace'],
        },
        {
          name: 'municipality',
          component: 'CustomDropDown',
          options: this.filters.municipalities,
          placeholder: 'Seleccione',
          label: 'Municipio:',
          fieldName: 'name',
          fieldKey: 'id',
          clearable: true,
          isAdvanced: true,
          class: 'col-md-4',
          onChanged: this.onMunicipalityChange,
          returnModel: true,
        },
        {
          name: 'servicePlace',
          component: 'CustomDropDown',
          options: this.filters.servicePlaces,
          initialValue: null,
          placeholder: 'Seleccione',
          label: 'Lugar de Servicios:',
          fieldName: 'name',
          fieldKey: 'id',
          clearable: true,
          isAdvanced: true,
          class: 'col-md-4',
          disabled: ['typePlace'] || this.filters.servicePlaces.length == 1,
          visible: this.isServicePlacesVisible,
          validations: 'required',
          returnModel: true,
        },
        {
          name: 'serviceType',
          component: 'CustomDropDown',
          options: this.filters.servicesTypes,
          initialValue: null,
          placeholder: 'Seleccione',
          label: 'Tipo de Servicio:',
          fieldName: 'name',
          fieldKey: 'id',
          clearable: true,
          isAdvanced: true,
          class: 'col-md-4',
          onChanged: this.onServiceTypeChanged,
          clearModelsOnUpdate: ['service'],
        },
        {
          name: 'service',
          component: 'CustomDropDown',
          options: this.filters.services,
          initialValue: null,
          placeholder: 'Seleccione',
          label: 'Servicio:',
          fieldName: 'name',
          fieldKey: 'id',
          clearable: true,
          isAdvanced: true,
          class: 'col-md-4',
          disabled: ['serviceType'],
        },
        {
          name: 'status',
          component: 'CustomDropDown',
          options: this.filters.status,
          initialValue: this.filters.status[2],
          placeholder: 'Seleccione',
          label: 'Estatus:',
          fieldName: 'name',
          fieldKey: 'id',
          clearable: true,
          isAdvanced: true,
          class: 'col-md-4',
        },
      ];
    },
    isServicePlacesVisible() {
      return this.userHasPermissions('level.location');
    },
    showAlert() {
      return (item) =>
        item.moreThanOneCompany &&
        (item.hasExcemptionSumitted ||
          item.hasExcemptionApproved ||
          item.hasExcemptionDenied);
    },
  },
  async mounted() {
    await getSpecialistYears().then(({ data }) => (this.filters.years = data));
    await getTypePlaces(8).then(({ data }) => (this.filters.typePlaces = data));
    await getServiceTypes(ServiceTypeCategories.Specialist).then(
      ({ data }) => (this.filters.servicesTypes = data)
    );
    await getMunicipalities({
      academicYearId: this.$store.state.$_common.currentAcademicYear,
    }).then((data) => {
      this.filters.municipalities = data;
    });
    if (this.hasSearched) {
      this.search(this.filterModel);
    }
  },
  async created() {
    await this.recoveryData();
  },
  destroyed() {
    this.persistData();
  },
  methods: {
    async add() {
      if (this.user.profile.companyid == null) {
        const isValid = await this.$refs.filterComponent.$refs.formValidator.validate();

        if (!isValid) {
          this.ShowToast(
            'Error',
            ' Es requerido seleccionar Proveedor.',
            'error'
          );
          return;
        }
      }
      this.$router.push({
        name: 'specialist-management',
        params: {
          specialistId: 0,
          fiscalYearId: this.currentAcademicYearId,
          companyId:
            this.user.profile.companyid == null
              ? this.filterModel.provider?.id
              : this.user.profile.companyid,
        },
      });
    },
    getPreviousPage(isSingleSpecialist) {
      return isSingleSpecialist
        ? 1
        : this.$store.state.moduleGenerated?.data?.SearchSpecialist?.pagination
            ?.currentPage;
    },
    search(data) {
      if (data) {
        getSpecialists({
          fiscalYearId: (data.academicYear || {}).id,
          companyId: (data.provider || {}).id,
          locationFiscalYearId: null,
          locationTypeId: (data.typePlace || {}).id,
          serviceLocationId: (data.servicePlace || {}).id,
          serviceTypeId: (data.serviceType || {}).id,
          disciplineTypeId: (data.service || {}).id,
          isActive:
            (data.status && data.status.id) >= 0
              ? !!(data.status || {}).id
              : null,
          specialistId: data.specialist?.id,
          page: data.page || this.getPreviousPage(data.specialist?.id) || 1,
          pageSize: 15,
        }).then(({ data: response }) => {
          this.hasSearched = true;
          this.results = response.data;
          this.pagination = {
            ...this.pagination,
            count: response.count,
            pageCount: response.pageCount,
            totalItemCount: response.totalItemCount,
            currentPage: response.currentPage,
          };
        });
      } else {
        //TODO: crear
        this.ShowToast(
          'Error',
          'Favor de completar la información solicitada.',
          'error'
        );
      }
    },
    onServiceTypeChanged(serviceType) {
      getServicesDiscipline(serviceType.id).then(
        ({ data }) => (this.filters.services = data)
      );
    },
    async onTypePlaceChanged({ academicYear, provider, typePlace }) {
      let companyId = this.userHasPermissions(
        'provider.specialist.dropdown.view'
      )
        ? (provider || {}).id
        : this.user.profile.companyid;

      await getServicePlaces({
        fiscalYearId: academicYear ? academicYear.id : null,
        companyId,
        locationTypeId: typePlace ? typePlace.id : null,
      }).then(
        ({ data }) =>
          (this.filters.servicePlaces = this.$deleteArrayObjectDuplicates(
            data,
            'id'
          ))
      );
      if (this.filters.servicePlaces.length == 1) {
        this.filterModel.servicePlace = this.filters.servicePlaces[0];
      }
    },
    onMunicipalityChange({ academicYear, provider, typePlace, municipality }) {
      let companyId = this.userHasPermissions(
        'provider.specialist.dropdown.view'
      )
        ? (provider || {}).id
        : this.user.profile.companyid;
      getServicePlaces({
        fiscalYearId: academicYear ? academicYear.id : null,
        companyId,
        locationTypeId: typePlace ? typePlace.id : null,
        municipalityId: municipality ? municipality.id : null,
      }).then(
        ({ data }) =>
          (this.filters.servicePlaces = this.$deleteArrayObjectDuplicates(
            data,
            'id'
          ))
      );
    },
    async onYearChanged(model) {
      if (this.userHasPermissions('provider.specialist.dropdown.view')) {
        await providersList({ fiscalYearId: model.id }).then(
          (data) => (this.filters.providers = data)
        );
        if (this.filters.providers.length == 1) {
          this.filterModel.provider = this.filters.providers[0];
          let payload = {
            academicYear: model,
            provider: this.filterModel.provider,
          };
          this.onProviderChanged(payload);
        }
      } else {
        const { data } = await specialistsList({ fiscalYearId: model.id });
        this.filters.specialists = data;
        if (this.filters.specialists.length == 1) {
          this.filterModel.specialist = this.filters.specialists[0];
        }
      }
    },
    async onProviderChanged({ academicYear, provider }) {
      const { data } = await specialistsList({
        fiscalYearId: academicYear.id,
        providerId: provider.id,
      });

      this.filters.specialists = data;
      if (this.filters.specialists.length == 1) {
        this.filterModel.specialist = this.filters.specialists[0];
      }
    },
    pageChanged(page) {
      this.$refs.filterComponent.search({ page });
    },
    alertText(item) {
      let text = '';

      if (item.moreThanOneCompany && item.hasExcemptionSumitted) {
        text =
          '<p class="mb-0">Especialista se encuentra en proceso de aprobación de dispensa por parte del Departamento de Educación de Puerto Rico.</p>';
      }

      if (item.moreThanOneCompany && item.hasExcemptionApproved) {
        text =
          '<p class="mb-0">La dispensa fue aprobada por el Departamento de Educación de Puerto Rico.</p>';
      }
      return text;
    },
    navigateToDispenseManagement() {
      this.$router.push('/provider/dispenseManagement');
    },
  },
};
</script>

<style lang="scss" scoped>
.rb-alert {
  background-color: #feeeb7;
  border: 1px solid #fdac41;
  border-top: 0px;
  border-radius: 0px 0px 5px 5px !important;
  .alert-text,
  .fa-bell-exclamation {
    color: #af6708;
  }
}

.text-dark-yellow {
  color: #af6717;
}
</style>
